import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment';
import { Injectable } from "@angular/core";

@Injectable()
export class FMDateAdapter extends NativeDateAdapter {
    format(date: Date, displayFormat): string {
        return moment(date).format('DD.MM.YYYY');
    }
  }